/**
 * @author yan st
 * @date 2022-08-16 08:40
 * @Description:
 */
import { getfile, qspost } from "@/plugins/axios";

/*
 *   获取社会组织信息
 * */
export const getOrganDetail = () => qspost("/api/Organ/getOrganDetail", {});

/*
 *   申报单位属性列表
 * */
export const getOrganClassList = () =>
  qspost("/api/Organ/getOrganClassList", {});

/*
 *   项目方向列表
 * */
export const getProjectClassList = () =>
  qspost("/api/Project/getProjectClassList", {});

/*
 *   项目方向层级列表
 * */
export const getProjectClassLevelList = (parent_id) =>
  qspost("/api/Project/getProjectClassLevelList", {
    parent_id,
  });

/*
 *   城市列表
 * */
export const cityList = (parent_id) =>
  qspost("/cityList", {
    parent_id,
  });



/*
 *   项目申报
 * */
export const projectApplication = (
  id,
  project_name,
  project_class,
  project_direction,
  organ_class,
  province_id,
  city_id,
  land_area,
  mail_address,
  post_code,
  email,
  fax_phone,
  legal_person,
  corporate_code,
  charge_name,
  charge_job,
  charge_tel,
  charge_phone,
  contact_name,
  contact_job,
  contact_tel,
  contact_phone,
  implement_organ_name,
  implement_mail_address,
  implement_post_code,
  implement_email,
  implement_fax_phone,
  implement_charge_name,
  implement_charge_job,
  implement_charge_tel,
  implement_charge_phone,
  implement_contact_name,
  implement_contact_job,
  implement_contact_tel,
  implement_contact_phone,
  organ_introduce,
  project_introduce,
  project_assessment,
  funding_budget,
  self_account,
  self_percent,
  support_account,
  support_percent,
  account_record,
  total_account,
  other_file
) =>
  qspost("/api/Project/projectApplication", {
    id,
    project_name,
    project_class,
    project_direction,
    organ_class,
    province_id,
    city_id,
    land_area,
    mail_address,
    post_code,
    email,
    fax_phone,
    legal_person,
    corporate_code,
    charge_name,
    charge_job,
    charge_tel,
    charge_phone,
    contact_name,
    contact_job,
    contact_tel,
    contact_phone,
    implement_organ_name,
    implement_mail_address,
    implement_post_code,
    implement_email,
    implement_fax_phone,
    implement_charge_name,
    implement_charge_job,
    implement_charge_tel,
    implement_charge_phone,
    implement_contact_name,
    implement_contact_job,
    implement_contact_tel,
    implement_contact_phone,
    organ_introduce,
    project_introduce,
    project_assessment,
    funding_budget,
    self_account,
    self_percent,
    support_account,
    support_percent,
    account_record,
    total_account,
    other_file,
  });

/*
 *   项目申报
 * */
export const saveProjectApplication = (
  id,
  project_name,
  project_class,
  project_direction,
  organ_class,
  province_id,
  city_id,
  land_area,
  mail_address,
  post_code,
  email,
  fax_phone,
  legal_person,
  corporate_code,
  charge_name,
  charge_job,
  charge_tel,
  charge_phone,
  contact_name,
  contact_job,
  contact_tel,
  contact_phone,
  implement_organ_name,
  implement_mail_address,
  implement_post_code,
  implement_email,
  implement_fax_phone,
  implement_charge_name,
  implement_charge_job,
  implement_charge_tel,
  implement_charge_phone,
  implement_contact_name,
  implement_contact_job,
  implement_contact_tel,
  implement_contact_phone,
  organ_introduce,
  project_introduce,
  project_assessment,
  funding_budget,
  self_account,
  self_percent,
  support_account,
  support_percent,
  account_record,
  total_account,
  other_file,
  is_agree = 1,
  is_recheck = 0
) =>
  qspost("/api/Project/saveProjectApplication", {
    id,
    project_name,
    project_class,
    project_direction,
    organ_class,
    province_id,
    city_id,
    land_area,
    mail_address,
    post_code,
    email,
    fax_phone,
    legal_person,
    corporate_code,
    charge_name,
    charge_job,
    charge_tel,
    charge_phone,
    contact_name,
    contact_job,
    contact_tel,
    contact_phone,
    implement_organ_name,
    implement_mail_address,
    implement_post_code,
    implement_email,
    implement_fax_phone,
    implement_charge_name,
    implement_charge_job,
    implement_charge_tel,
    implement_charge_phone,
    implement_contact_name,
    implement_contact_job,
    implement_contact_tel,
    implement_contact_phone,
    organ_introduce,
    project_introduce,
    project_assessment,
    funding_budget,
    self_account,
    self_percent,
    support_account,
    support_percent,
    account_record,
    total_account,
    other_file,
    is_agree,
    is_recheck,
  });

/**
 * 补充资料
 * @param {*} data
 */
export const saveProjectFileInfo = (data) =>
  qspost("/api/Project/saveProjectFileInfo", data);

/**
 * 补充资料
 * @param {*} data
 */
export const saveEndProjectFileList = (data) =>
  qspost("/api/Project/saveEndProjectFileList", data);

/**
 * 补充资料
 * @param {*} data
 */
export const saveEndProjectFile = (data) =>
  qspost("/api/Project/saveEndProjectFile", data);

/**
 * 补充资料
 * @param {*} data
 */
export const saveProjectFileList = (data) =>
  qspost("/api/Project/saveProjectFileList", data);

/*
 *   申报项目列表
 * */
export const getProjectApplicationList = (
  pageIndex,
  pageSize,
  is_recheck = 0
) =>
  qspost("/api/Project/getProjectApplicationList", {
    pageIndex,
    pageSize,
    is_recheck,
  });

/*
 *   申报项目详情
 * */
export const getProjectApplicationDetail = (project_id) =>
  qspost("/api/Project/getProjectApplicationDetail", {
    project_id,
  });

/*
*   修改密码org

* */
export const updatePasswordOrg = (password, new_password) =>
  qspost("/api/Organ/updatePassword", {
    password,
    new_password,
  });

/*
*   修改密码admin

* */
export const updatePasswordAdmin = (password, new_password) =>
  qspost("/admin/Admin/updatePassword", {
    password,
    new_password,
  });

/*
 *   删除申报项目
 * */
export const deleteProjectInfo = (project_id) =>
  qspost("/api/Project/deleteProjectInfo", {
    project_id,
  });

/*
 *   项目撤回审核
 * */
export const exitProjectApplication = (project_id) =>
  qspost("/api/Project/exitProjectApplication", {
    project_id,
  });

/*
 *   上传承诺书
 * */
export const save_organ_Letter = (project_id, organ_letter, is_recheck = 0) =>
  qspost("/api/Project/saveLetter", {
    project_id,
    organ_letter,
    is_recheck,
  });

/*
 *   上传意见书
 * */
export const save_implement_letter = (project_id, implement_letter) =>
  qspost("/api/Project/saveLetter", {
    project_id,
    implement_letter,
  });

/*
 *   导出申报项目PDF文件
 * */
export const exportProjectPdf = (project_id) =>
  qspost("/api/Project/exportProjectPdf", {
    project_id,
  });

/*
 *   导出申报项目PDF文件
 * */
export const downloadPdf = (url) => getfile(url, {});

/*
 *   确认提交申报
 * */
export const projectApprove = (id, is_recheck = 0) =>
  qspost("/api/Project/projectApprove", {
    id,
    is_recheck,
  });

/*
 *   社会组织信息完善
 * */
export const updateOrganDetail = (organ_name,phone,code) =>
  qspost("/api/Organ/updateOrganDetail", {
    organ_name,phone,code
  });

/*
 *   确认提交申报
 * */
export const isEnd = () => qspost("/api/Organ/isEnd", {});

/*
 *   评分记录
 * */
export const getProjectScoreRecord = (project_id, type, project_score_id) =>
  qspost("/api/Project/getProjectScoreRecord", {
    project_id,
    type,
    project_score_id,
  });

/*
 *  月报项目列表
 * */
export const getProjectList = (pageIndex, pageSize) =>
  qspost("/api/Project/getProjectList", {
    pageIndex,
    pageSize,
  });

/*
 *  月报时间列表
 * */
export const getTimeList = () => qspost("/api/Project/getTimeList", {});

/*
 *  月报项目详情
 * */
export const getProjectDetail = (data) =>
  qspost("/api/Project/getProjectDetail", data);

/*
 *  项目月报详情
 * */
export const getProjectReportInfo = (data) =>
  qspost("/api/Project/getProjectReportInfo", data);

/*
 *  保存项目月报详情
 * */
export const saveProjectReportInfo = (data) =>
  qspost("/api/Project/saveProjectReportInfo", data);
